import "./Master.scss";
import { useHistory } from "react-router-dom";
import { Button, Content, DateInput, FormFields, usePathFactory, useTranslator } from "@sia/style-guide";
import Page from "../../../Page";
import { useContext, useEffect, useState, useCallback } from "react";
// import webPlatformAdapter from "common/Adapters/WebPlatformAdapter/WebPlatformAdapter";
import pgAdapter from "common/Adapters/PGAdapter/PGAdapter";
import GlobalContext from "contexts/GlobalContext";
import { masterGraduationDateCreator, WizarContext } from "contexts/WizardContext";

const MasterPage = () => {
  const translate = useTranslator();
  const pathFactory = usePathFactory();
  const history = useHistory();
  const { user } = useContext(GlobalContext);
  const { state, dispatch } = useContext(WizarContext);
  let changState = useCallback((payload) => dispatch(masterGraduationDateCreator(payload)), [dispatch]);
  const [dateError, setDateError] = useState(null);

  useEffect(() => {
    if (user) {
      pgAdapter.getWizardSession(({ data }) => {
        let masterGraduationDate = data?.masterGraduationDate;
        if (masterGraduationDate) {
          changState({ masterGraduationDate });
        }
      });
    }
  }, [user, changState]);

  const setUserSession = (value) => {
    pgAdapter.getWizardSession(({ data }) => {
      const updatedSession = { ...data, masterGraduationDate: value };
      pgAdapter.setWizardSession({ ...updatedSession });
    });
  };

  return (
    <Page>
      <Content width={"slim"} centeredTitle={true} centeredTexts={true}>
        <div className="master-page">
          <h1 className="productive-heading-04 sia-text-12 master-page__heading">{translate("wizard.sia-ways.title")}</h1>
          <FormFields>
            <DateInput
              value={state.masterGraduationDate}
              required={true}
              label={translate("wizard.master.input.label")}
              id={"master-date"}
              onChange={(event, value, error) => {
                setUserSession(value);
                changState({ masterGraduationDate: value });
                setDateError(error);
              }}
              className={"master-page__input"}
              invalidPatternText={translate("form.input.error.invalid.with-example", { example: "d.m.yyyy" })}
              invalidText={dateError}
            />
          </FormFields>
          <p>
            <Button
              onClick={() => {
                if (!state.masterGraduationDate) {
                  return;
                }
                history.push(pathFactory.create("wizard/member-options"));
              }}
            >
              {translate("wizard.sia-ways.to-login.button.label")}
            </Button>
          </p>
        </div>
      </Content>
    </Page>
  );
};

export default MasterPage;
